import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";

import { BACKEND_CONFIG } from "../config/consts";

export default class RouteWithLayout extends Component {
  render() {
    var {
      component,
      layout,
      allowUnauthorized,
      backgroundType,
      showMenu,
      ...rest
    } = this.props;

    return (
      <Route
        {...rest}
        render={(props) => {
          if (allowUnauthorized || BACKEND_CONFIG.get("auth")) {
            return React.createElement(
              layout,
              { ...props, backgroundType, showMenu, allowUnauthorized },
              React.createElement(component, { ...props, ...rest })
            );
          }
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        }}
      />
    );
  }
}
